import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { TournamentTypes } from 'common';

import GuaranteedIcon from 'targets/web/assets/icons/guaranteed-prize.svg?react';
import {
  formatToCurrency,
  getTotalPrizes,
  isGuaranteedPrize,
} from 'targets/web/modules/display/utils/tournamentUtils';

interface TournamentCardBodyTotalPrizesProps {
  tournament: TournamentTypes.TournamentConfig;
}

export const TournamentCardBodyTotalPrizes: FC<TournamentCardBodyTotalPrizesProps> = ({
  tournament,
}) => {
  const totalPrizes = getTotalPrizes(
    tournament.payoutType,
    tournament.minPayout,
    tournament.potAmount,
  );
  const showGuaranteedPrize = isGuaranteedPrize(
    tournament.payoutType,
    tournament.minPayout,
    tournament.potAmount,
  );

  return (
    <Stack
      sx={{
        px: 6,
        height: 180,
        justifyContent: 'center',
        borderRadius: '8px',
        borderWidth: 3,
        borderColor: 'primary.main',
        borderStyle: 'solid',
      }}>
      <Stack flexDirection="row" gap={6} alignItems="center" justifyContent="space-between">
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 6,
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
          }}>
          <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '64px', color: 'primary.main' }}>
            Total Prizes
          </Typography>
          <Stack flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '64px', color: 'primary.main' }}>
              {formatToCurrency(totalPrizes)}
            </Typography>
            {showGuaranteedPrize && (
              <span style={{ marginTop: 10 }}>
                <GuaranteedIcon />
              </span>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
